import { Box } from "@mui/material";
import MuiTypography from "@mui/material/Typography";
import styled from "styled-components";

export const Content = styled(Box)`
  padding: 16px 8px 16px 8px;
`;

export const TypographyWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 12px;
  white-space: pre-wrap;
  margin-bottom: 30px;
`;

export const Typography = styled(MuiTypography)<{ color?: string }>`
  color: ${(props) => props.color || props.theme.text.primary};
  font-size: 16px;
  font-family: "NotoSans-Medium";
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
`;
